import { BaseProvider } from "./base.provider";

export interface Place {
  lat: number;
  lng: number;
  name: string;
  distance_m: number;
  street_address: string;
}

export interface PlaceCollection {
  places: Place[] | null;
  next_page_token: string;
}

export interface GoogleRoutesResponse {
  routes: Array<{
    distanceMeters: number;
    duration: string;
    polyline: {
      encodedPolyline: string;
    };
    legs: Array<{
      distanceMeters: number;
      duration: string;
    }>;
  }>;
}

export interface MapObj {
  obj_type: string;
  lat: number;
  lng: number;
  primary_color: string;
  secondary_color: string;
  name: string;
  icon_name: string | null;
  image_url: string | null;
}

class LocationsProvider extends BaseProvider {
  search(query: string, lat: number, lng: number): Promise<PlaceCollection> {
    return this.request<PlaceCollection>(
      `/v1/locations/${encodeURIComponent(query)}/${lat}/${lng}`,
    );
  }

  getRoute(
    traffic: boolean,
    origin: { lat: number; lng: number },
    dest: { lat: number; lng: number },
  ): Promise<GoogleRoutesResponse> {
    return this.request<GoogleRoutesResponse>(
      `/v1/locations/route/${traffic}/${origin.lng}/${origin.lat}/${dest.lng}/${dest.lat}`,
    );
  }

  getMapObjs(): Promise<MapObj[]> {
    return this.request<MapObj[]>(`/v1/tmp/map-objs`);
  }
}

export const locationsProvider = new LocationsProvider();
